export default __webpack_public_path__ + "files/f7b8693e7a04473a56499a07f03bc7de.mp3";